///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';
import { UserAuthorities } from './services/user/user-authorities';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { canActivateUser } from './shared/auth/user-route-access-service';
import { UpdateEulaDialogWrapperComponent } from './global-dialogs/eula/update/update-eula-dialog-wrapper.component';

export const navbarRoute: Route[] = [
    {
        path: '',
        component: NavbarComponent,
        outlet: 'navbar',
        title: 'WiNDE'
    },
    {
        path: 'release-notes',
        loadChildren: () => import('./help/release-notes/release-notes.module').then((m) => m.GtthReleaseNotesModule),
        data: {
            authorities: UserAuthorities.ALL
        },
        title: 'Release notes',
        canActivate: [canActivateUser]
    },
    {
        path: 'user-manual',
        loadChildren: () => import('./help/user-manual-new/user-manual.module').then((m) => m.GtthUserManualModule),
        data: {
            authorities: UserAuthorities.ALL
        },
        title: 'User manual',
        canActivate: [canActivateUser]
    },
    {
        path: 'system-reports',
        loadChildren: () => import('./system-reports/system-reports.module').then((m) => m.GtthSystemReportsModule),
        data: {
            authorities: UserAuthorities.ALL_SIKLU
        },
        title: 'System reports',
        canActivate: [canActivateUser]
    },
    {
        path: 'engineers',
        loadChildren: () => import('./engineers-config/engineers.module').then((m) => m.GtthEngineersModule),
        data: {
            authorities: UserAuthorities.ALL_SIKLU
        },
        title: 'Siklu',
        canActivate: [canActivateUser]
    },
    {
        path: 'users',
        loadChildren: () => import('./users-config/users.module').then((m) => m.GtthUsersModule),
        data: {
            authorities: [UserAuthorities.COMPANY_ADMIN]
        },
        title: 'Users',
        canActivate: [canActivateUser]
    },
    {
        path: 'customers',
        loadChildren: () => import('./customers-config/customers.module').then((m) => m.GtthCustomersModule),
        data: {
            authorities: UserAuthorities.ALL_SIKLU
        },
        title: 'Customers',
        canActivate: [canActivateUser]
    },
    {
        path: 'products',
        loadChildren: () => import('./entities/entities.module').then((m) => m.GtthEntitiesModule),
        data: {
            authorities: UserAuthorities.ALL
        },
        title: 'Products',
        canActivate: [canActivateUser]
    },
    // global pop-ups
    {
        path: 'eula/update',

        component: UpdateEulaDialogWrapperComponent,
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT],
            pageTitle: 'eula.title.update'
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    }
];
